/// <amd-module name="Build/Designer/Performance" />
export namespace PerformanceConstants {
    export const Area = "Build";
}

// Note: isDebugMode might affect these scenarios, when gathering data, making sure debug mode is ignored

// "how long did it take for the user, starting from navigation, to show some interactive elements on the hub?"
// From the navigation time to the point where the data relevant to the user is shown
// These mark TTI
export namespace PageLoadScenarios {
    export const Sources = "PLT.CI.AcquisitionWizard.Sources";
    export const YamlEditor = "PLT.CI.YamlEditor";
    export const Repository = "CI.Designer.Repository";
    export const Templates = "CI.Designer.Templates";
}
